import React from "react";

export function LandingFooter() {
  return (
    <footer className="relative z-10 px-6 md:px-12 lg:px-24 py-12 bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <a href="/" className="inline-flex items-center gap-2 mb-4" aria-label="AdWup.ai — go to homepage">
              <img
                src="/images/mascots/icon-green.png"
                alt=""
                aria-hidden="true"
                className="h-10 w-10"
                data-testid="footer-mascot"
              />
              <img src="/images/logo-light.png" alt="AdWup.ai logo" className="h-10 w-auto brightness-0 invert" />
            </a>
            <p className="text-gray-500 text-sm">AI-powered listing marketing for real estate professionals.</p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Product</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="/features" className="hover:text-[#00FF00] transition-colors">Features</a></li>
              <li><a href="/pricing" className="hover:text-[#00FF00] transition-colors">Pricing</a></li>
              <li><a href="/faq" className="hover:text-[#00FF00] transition-colors">FAQ</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Company</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="/about" className="hover:text-[#00FF00] transition-colors">About</a></li>
              <li><a href="/contact" className="hover:text-[#00FF00] transition-colors">Contact</a></li>
              <li><a href="/contact" className="hover:text-[#00FF00] transition-colors">Support</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li><a href="/privacy" className="hover:text-[#00FF00] transition-colors">Privacy</a></li>
              <li><a href="/terms" className="hover:text-[#00FF00] transition-colors">Terms</a></li>
              <li><a href="/cookies" className="hover:text-[#00FF00] transition-colors">Cookies</a></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 text-center text-gray-500 text-sm">
          © 2026 AdWup Technologies Inc. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
